export const GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME = 'name'
